(function ($, Drupal) {
  // Header behaviors (Sticky, scroll direction...)
  Drupal.behaviors.checkout = {
    attach(context, settings) {
      if ($(".layout-checkout-form").length) {
        const select = $(
          "#edit-shipping-information-shipping-profile-address-0-address-country-code--2"
        );
        const nextButton = $("#edit-actions-next");
        const productTitleObject = $(".product__title").find("a");
        const product__title = productTitleObject.toArray();
        let hasMassager = false;

        // Set the flag for checking massager
        product__title.forEach((element) => {
          const elementText = $(element).text().toLowerCase();
          if (elementText.includes("massager")) {
            hasMassager = true;
          }
        });

        function updateButtonState() {
          const selectedCountry = select.val();

          if (hasMassager && (selectedCountry === "MA" || selectedCountry === "EG")) {
            nextButton.prop("disabled", true);

            // Add styling
            product__title.forEach((element, index) => {
              const elementText = $(element).text().toLowerCase();
              if (elementText.includes("massager")) {
                const elementGrandparent = $(element)
                  .closest("tr")
                  .addClass("massager-restriction");

                const title =
                  "This item is not eligible for shipping to your country.";
                const text = `To proceed with the checkout, please click <a class="edit-button" href="/cart"><strong>EDIT</strong></a> to remove this item from your shopping cart.`;
                elementGrandparent.append(
                  `<div class="container"><div class="icon"></div><div class="textContainer"><p class="title">${title}</p><p class="text">${text}</p></div></div>`
                );

                // Set different border radius based on index
                if (index === 0) {
                  elementGrandparent.css("border-top-right-radius", "8px");
                  elementGrandparent.css("border-top-left-radius", "8px");
                } else if (index === product__title.length - 1) {
                  elementGrandparent.css("border-bottom-right-radius", "8px");
                  elementGrandparent.css("border-bottom-left-radius", "8px");
                } else {
                  elementGrandparent.css("border-radius", "0px");
                }
              }
            });
          } else {
            nextButton.prop("disabled", false);
            // Remove styling
            product__title.forEach((element) => {
              const elementGrandparent = $(element).closest("tr");
              elementGrandparent.removeClass("massager-restriction");
              elementGrandparent.find(".container").remove();
            });
          }
        }

        select.off("change").on("change", updateButtonState);

        // Call the updateButtonState to set the initial state
        updateButtonState();
      }
    },
  };
})(jQuery, Drupal);
